@if (!history?.length) {
    <p class="text-muted mb-0">No history yet.</p>
} @else {
    <ul class="list-unstyled mb-0 permit-history">
        @for (entry of orderedHistory; track $index; let last = $last) {
            <li class="d-flex">
                <div class="permit-history__marker"></div>
                <!-- No trailing gap under the last entry - the timeline ends with the entry,
             not with empty space below it. -->
                <div class="permit-history__body" [class.pb-3]="!last">
                    <div class="fw-semibold">{{ label(entry) }}</div>
                    <div class="small text-muted">
                        {{ entry.at | date: 'd MMM y, h:mm a' }}
                        @if (showActor && entry.by) {
                            · {{ entry.by }}
                        }
                    </div>
                    @if (entry.note) {
                        <!-- pre-line so a note written across several lines (e.g. an extension's
                 reason under its dates line) keeps those breaks instead of running together. -->
                        <div class="small mt-1 permit-history__note">{{ entry.note }}</div>
                    }
                </div>
            </li>
        }
    </ul>
}
